import * as React from 'react';
import { CalendarHeader } from './CalendarHeader.js';
import { CalendarLabel } from './CalendarLabel.js';
import { MonthYearButton } from './MonthYearButton.js';
import { MonthYearContainer } from './MonthYearContainer.js';
import { useMonthPicker } from './useMonthPicker.js';
import { formatYear } from './util/index.js';

var MonthPicker = function MonthPicker(props) {
  var locale = props.locale,
    calendarYear = props.calendarYear,
    onCalendarChange = props.onCalendarChange,
    containerGridRef = props.containerGridRef;
  var _useMonthPicker = useMonthPicker(props),
    getButtonCellProps = _useMonthPicker.getButtonCellProps,
    calendarHeaderProps = _useMonthPicker.calendarHeaderProps;
  return /*#__PURE__*/React.createElement(MonthYearContainer, {
    testId: "month-picker",
    containerGridRef: containerGridRef,
    header: /*#__PURE__*/React.createElement(CalendarHeader, calendarHeaderProps, /*#__PURE__*/React.createElement(CalendarLabel, {
      label: formatYear(calendarYear, locale),
      onClick: function onClick() {
        return onCalendarChange('year');
      }
    })),
    buttonCell: function buttonCell(monthCount) {
      return /*#__PURE__*/React.createElement(MonthYearButton, getButtonCellProps(monthCount));
    }
  });
};

export { MonthPicker };
//# sourceMappingURL=MonthPicker.js.map
